const WORDS_PER_MINUTE = 235;

function stripHtml(value = '') {
  return String(value)
    .replace(/<style[\s\S]*?<\/style>/gi, ' ')
    .replace(/<script[\s\S]*?<\/script>/gi, ' ')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'")
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/\s+/g, ' ')
    .trim();
}

function collectArticleText(article = {}) {
  const container = article?.post_container && typeof article.post_container === 'object'
    ? article.post_container
    : {};
  const textBlocks = Array.isArray(container.post_texts)
    ? container.post_texts
    : Array.isArray(article.post_texts)
      ? article.post_texts
      : [];

  const textParts = [
    article?.title,
    container?.post_title,
    article?.description,
    container?.post_description,
    ...textBlocks.map((block) => block?.content),
  ]
    .filter((part) => typeof part === 'string' && part.trim().length > 0)
    .map(stripHtml)
    .filter(Boolean);

  return textParts.join(' ').trim();
}

export function getArticleReadingTimeMinutes(article = {}) {
  const text = collectArticleText(article);
  if (!text) {
    return 1;
  }

  const wordCount = text.split(/\s+/).filter(Boolean).length;
  return Math.max(1, Math.ceil(wordCount / WORDS_PER_MINUTE));
}

export function formatArticleReadingTime(article = {}) {
  return `${getArticleReadingTimeMinutes(article)} MIN READ`;
}

export { WORDS_PER_MINUTE };
